import Navbar from "./Components/Navbar";
import { useState, useEffect } from "react";
import { isMobile } from "react-device-detect";
import MobileNavBar from "./Mobile/MobileComponents/MobileNavBar";
import { membersList } from "./membersList";
import { siteList } from "./siteList";

const FLY_URL = "https://minebikersmcc-backend.fly.dev";
const LOCAL_URL = "http://localhost:3001";
// const AWS_URL = "https://vnfmu6bxo9.execute-api.eu-north-1.amazonaws.com/prod"
// In your App.js or config file
export const BASE_URL =
  process.env.NODE_ENV === "production" ? FLY_URL : LOCAL_URL;

const getWindowWidth = () => {
  const { innerWidth: width } = window;
  return width;
};

export default function App() {
  const [currentWidth, setCurrentWidth] = useState();

  useEffect(() => {
    function handleResize() {
      setCurrentWidth(getWindowWidth());
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      {isMobile || currentWidth < 800 ? (
        <MobileNavBar members={membersList} sites={siteList} />
      ) : (
        <Navbar members={membersList} sites={siteList} />
      )}
    </div>
  );
}
